<template>
  <div class="flex flex-col">
    <!-- Top Level Link-->
    <sidebar-link
      role="button"
      tabindex="0"
      class="cursor-pointer"
      :class="[
        activeRoute
          ? 'font-medium text-white'
          : 'font-normal text-white/80 hover:text-white hover:bg-blue-900/70',
      ]"
      :id="toggleId"
      :aria-controls="panelId"
      :aria-expanded="accordianIsOpen"
      @click="toggleAccordian"
      @keydown.space="toggleAccordian"
      @keydown.enter="toggleAccordian"
    >
      <span class="flex justify-between items-center gap-2 w-full drop-shadow">
        <span class="flex items-center gap-2.5">
          <s-icon
            v-if="!!icon"
            :name="icon"
            :class="activeRoute ? 'text-s-red-200' : 'text-blue-200'"
          />
          <span class="flex flex-col">
            <slot />
            <span v-if="subtext" class="text-sm font-normal leading-tight text-white/80">
              {{ subtext }}
            </span>
          </span>
        </span>
        <icon-chevron-down
          class="h-4 w-4 mb-1 transition-transform ease-in-out"
          :class="{'rotate-180': accordianIsOpen}"
          role="presentation"
        />
      </span>
    </sidebar-link>

    <nav
      v-if="links.length"
      :id="panelId"
      :aria-labelledby="toggleId"
      :aria-hidden="!accordianIsOpen"
      class="transition-[grid-template-rows] ease-out duration-200 grid min-h-0 overflow-hidden -mt-1 mb-1"
      :class="accordianIsOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr] no-touching'"
      :hidden="!accordianIsOpen"
      :visibility="accordianIsOpen ? 'visible' : 'hidden'"
    >
      <div
        class="w-full overflow-hidden transition-opacity ease-out duration-200"
        :class="accordianIsOpen ? 'opacity-100' : 'opacity-0'"
      >
        <ul class="text-sm flex flex-col pl-3 pt-1 pb-2">
          <li v-for="item in links" :key="item.label" class="flex w-full">
            <sidebar-item :item="item" class="flex-1">
              {{ item.label }}
            </sidebar-item>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script lang="ts" setup>
import {ref, watch, computed} from 'vue';
import SidebarLink from './SidebarLink.vue';
import SidebarItem from './SidebarItem.vue';
import IconChevronDown from '../icons/IconChevronDown.vue';
import {usePage} from '@inertiajs/vue3';
import SIcon from '../../design-system/SIcon.vue';

const props = defineProps<{
  subtext?: string;
  prefix?: string;
  icon?: string;
  links: any[];
}>();

const randomId = Math.random().toString(36).substring(7);
const toggleId = `toggle-${randomId}`;
const panelId = `panel-${randomId}`;

const page = usePage();
const activeRoute = computed(() => {
  // Little janky but it can be improved once we're off the legacy frontend.
  return props.prefix
    ? page.url.startsWith(props.prefix) || page.url.startsWith('/web' + props.prefix)
    : false;
});

const accordianIsOpen = ref<boolean>(activeRoute.value);

watch(activeRoute, (newVal) => {
  if (newVal) {
    accordianIsOpen.value = true;
  } else {
    accordianIsOpen.value = false;
  }
});

const toggleAccordian = () => {
  accordianIsOpen.value = !accordianIsOpen.value;
};
</script>
